import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

export function LanguagePopover() {
  const { currentLang, allLangs, onChangeLang } = useLocales();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="h-9 w-9 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors">
          <Iconify icon="lucide:languages" width={20} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-48 rounded-xl border-gray-100 shadow-xl bg-white/95 backdrop-blur-sm"
        align="end"
      >
        {allLangs.map((lang) => (
          <DropdownMenuItem
            key={lang.value}
            onClick={() => onChangeLang(lang.value)}
            className={`flex items-center gap-2 ${
              currentLang.value === lang.value ? 'bg-[#7C3AED]/10 text-[#7C3AED]' : ''
            }`}
          >
            <span className="text-base">{lang.icon}</span>
            <span>{lang.label}</span>
            {currentLang.value === lang.value && (
              <Iconify icon="lucide:check" width={16} className="ml-auto" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
